// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/wfdl-builtin-plugin

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function ElementList(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'ElementList',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fill: 'currentColor',
      d: 'M4 2v1h7V2zM1 3h1V2H1zm3 3h7V5H4zM1 6h1V5H1zm3 3h7V8H4zM1 9h1V8H1z',
    })
  );
}
